import { useState, useCallback, useEffect } from 'react'
import { withStyles } from '@aura/components/styles'
import Box from '@aura/components/box'
import CircularProgress from '@aura/components/circular-progress'
import Typography from '@aura/components/typography'
import Link from '@aura/components/link'
import FormHelperText from '@aura/components/form-helper-text'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import RegistrationContainerNew from '../../../../components/registration-container-new'
import styles from './styles'


const Component = ({
    classes,
    error,
    factorId,
    initPush,
    onResend,
    resendSuccess,
    resendSuccessMsg,
    title,
    verbiage
}) => {

    const { t: translate } = useTranslation()
    const [ timer, setTimer ] = useState(30)
    const [ canResend, setCanResend ] = useState(false)
    const [ isTimerRunning, setIsTimerRunning ] = useState(true)

    useEffect(() => {
        initPush({ factorId })
    }, [])

    const handleResend = useCallback(event => {
        event.preventDefault()
        if (canResend) {
            setCanResend(false)
            setIsTimerRunning(true)
            setTimer(30)
            onResend()
        }
    }, [ onResend, canResend ])

    useEffect(() => {
        if (resendSuccess) {
            initPush({ factorId })
        }
    }, [ resendSuccess ])

    useEffect(() => {
        let countdown

        if (isTimerRunning && timer > 0) {
            countdown = setTimeout(() => {
                setTimer(prevTimer => {
                    const newTimer = prevTimer - 1

                    if (newTimer <= 0) {
                        setCanResend(true)
                        setIsTimerRunning(false)
                        return 0
                    }

                    return newTimer
                })
            }, 1000)
        }

        return () => {
            if (countdown) {
                clearTimeout(countdown)
            }
        }
    }, [ timer, isTimerRunning ])

    return (
        <RegistrationContainerNew {...{ title: translate(`authenticatorOptions.${title}`), verbiage: translate(`authenticatorOptions.${verbiage}`) }}>
            <Box className={classes.fieldsContainer}>
                {!error && (<Box className={classes.actions}>
                    <Link
                        className={`${canResend ? classes.link : classes.disabledLink}`}
                        href=""
                        onClick={handleResend}
                        underline="none"
                        style={{
                            pointerEvents: canResend ? 'auto' : 'none'
                        }}
                    >
                        {translate('resend')}
                    </Link>
                    {isTimerRunning && (
                        <Box className={classes.countdown}>
                            <CircularProgress variant="determinate" className={classes.countdownProgress} value={(timer / 30) * 100} size={30} thickness={5} />
                            <Typography variant="caption" className={classes.countdownTypography}>{timer}</Typography>
                        </Box>
                    )}
                </Box>)}
                <Box className={classes.successMsg}>
                    {(resendSuccessMsg !== '' && error === null) ? translate('loginFlow.push.resendMessagePushSucess') : ''}
                </Box>
                <FormHelperText error>{error && translate('oktaApiResponse.' + `${error}`)}</FormHelperText>
            </Box>
        </RegistrationContainerNew>
    )
}

Component.displayName = 'Push'

Component.propTypes = {
    classes: PropTypes.shape({
        button: PropTypes.object,
        loader: PropTypes.object,
        root: PropTypes.object
    }),
    error: PropTypes.string,
    factorId: PropTypes.string,
    initPush: PropTypes.func.isRequired,
    isBackAllowed: PropTypes.bool,
    onBack: PropTypes.func,
    onResend: PropTypes.func.isRequired,
    resendSuccess: PropTypes.bool,
    resendSuccessMsg: PropTypes.string,
    title: PropTypes.string,
    verbiage: PropTypes.string
}

export default withStyles(Component, styles)
